import React from 'react';
import { Chip, Tooltip } from '@mui/material';

// "D" marker for screens that still show dummy data until their backend is built.
const DummyBadge = ({ label = 'Dummy data — sample values until the backend is ready', sx }) => (
  <Tooltip title={label}>
    <Chip
      label="D"
      size="small"
      color="warning"
      sx={{ height: 18, minWidth: 18, fontSize: '0.625rem', fontWeight: 700, '& .MuiChip-label': { px: 0.6 }, ...sx }}
    />
  </Tooltip>
);

export default DummyBadge;
